import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { startNoOpTenderOrder, startOfflineCardOrder, startOnlineCardOrder, startTabWithRemotePayment } from '../../actions/order'
import { clearRemoteOrderTotal, getRemoteOrderTotal } from '../../actions/orderTotalRemote'
import { fetchOrderingPreferences } from '../../actions/suites/orderingPreference'

import { getSubtotal, getTotal, getCartQuantity2 } from '../../selectors/cart'
import { makeGetCurrentMenu } from '../../selectors/menus'
import { makeGetRemoteOrderTotal } from '../../selectors/orderTotalRemote'
import { makeGetActiveCustomerPreferences, suiteCustomerIsOrdering } from '../../selectors/suites'

import { ORDER_STATES } from '../../utils/orderStates'
import { makeExemptions, makeTotalDisplayWithExemptions } from '../../utils/orderTotalUtils'

import CartDetailsViewModel from '../../viewmodels/CartDetailsViewModel'

import StartTabModal from '../../components/tabs/StartTabModal'
import { getPeripheralStatus } from '../../selectors/peripheral'
import { makeGetNoOpTenders } from '../../selectors/revenueCenter'

const mapStateToProps = (state, ownProps) => {
  const subtotal = getSubtotal(state)
  const total = getTotal(state)
  const itemCount = getCartQuantity2(state)

  const selectRemoteOrderTotal = makeGetRemoteOrderTotal()
  const remoteOrderTotal = selectRemoteOrderTotal(state)

  const isSuiteCustomer = suiteCustomerIsOrdering(state)
  let orderingPreference = {}
  // NOTE (westinschepper): This is temporary
  let paymentOptions = [
    {
      "customerId": null,
      "token": null,
      "paymentType": 24,
      "userAttributes": null,
      "externalRefId": "direct bill",
      "shortDescription": "Open w/o Payment",
      "salesEventId": null,
      "nickname": null,
      "uuid": null,
      "paymentDisplay": "Open w/o Payment"
    }
  ]

  if (isSuiteCustomer) {
    const getActiveCustomerPreferences = makeGetActiveCustomerPreferences()
    orderingPreference = getActiveCustomerPreferences(state)

    const getCurrentMenu = makeGetCurrentMenu()
    const menuSubtype = get(getCurrentMenu(state), 'subtype')
    paymentOptions = get(orderingPreference, `${menuSubtype}.payments`)
  }

  const exemptions = makeExemptions(remoteOrderTotal, orderingPreference)
  const totalDisplayWithExemptions = makeTotalDisplayWithExemptions(exemptions, remoteOrderTotal, total)
  const cartDetails = CartDetailsViewModel({ subtotal, total })
  const peripheralStatus = getPeripheralStatus(state)
  const noOpPayments = makeGetNoOpTenders()(state)

  return {
    ...cartDetails,
    exemptions,
    itemCount,
    isSuiteCustomer,
    noOpPayments,
    orderingPreference,
    paymentOptions,
    peripheralStatus,
    remoteOrderTotal,
    totalDisplayWithExemptions,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = get(ownProps, 'history.replace', () => {})

  return {
    onSuccess: (data, userNotes, exemptionOverrides) => {
      const params = { cardReaderData: data, userNotes, state: ORDER_STATES['TABBED'], exemptionOverrides }
      dispatch(startOnlineCardOrder(params))
    },
    onDone: () => {
      replace('/tabs')
    },
    onMount: () => {
      dispatch(getRemoteOrderTotal())
      dispatch(fetchOrderingPreferences())
    },
    onRemotePayment: (exemptionOverrides, paymentPreference, userNotes) => {
      dispatch(startTabWithRemotePayment({ exemptionOverrides, paymentPreference, userNotes }))
      replace('/tabs')
    },
    onSelectNoOpPayment: (exemptionOverrides, userNotes) => replace('/tab-order/start-tab/select-payment', { exemptionOverrides, userNotes }),
    clearRemoteOrderTotal: () => dispatch(clearRemoteOrderTotal()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StartTabModal))
